import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import useEnterpriseNextUp from '#client/hooks/enterpriseHome/useEnterpriseNextUp';

import { EnterpriseNextUpCard } from './components/EnterpriseNextUpCard';
import * as Styled from './EnterpriseNextUp.style';

function EnterpriseNextUp() {
  const { formatMessage } = useIntl();
  const { cards, loading } = useEnterpriseNextUp();

  if (!loading && cards.length === 0) {
    return null;
  }

  return (
    <HomeSection
      title={(
        <Text size="xl" weight="medium" loading={loading}>
          {!loading && <FormattedMessage id="dashboard.enterpriseNextUp.title" />}
        </Text>
      )}
    >
      {loading ? (
        <Skeleton data-testid="enterprise-next-up-skeleton" height={300} />
      ) : (
        <Styled.CardList component="ul">
          {cards.map((card, idx) => (
            <Styled.CardItem
              component="li"
              key={card.type}
            >
              <EnterpriseNextUpCard
                ctaType={card.ctaType}
                ctaUrl={card.ctaUrl}
                description={formatMessage({ id: card.descriptionId })}
                estimate={card.estimate}
                highlight={cards.length > 1 && idx === 0}
                imageUrl={card.imageUrl}
                isLocked={card.isLocked}
                title={formatMessage({ id: card.titleId })}
              />
            </Styled.CardItem>
          ))}
        </Styled.CardList>
      )}
    </HomeSection>
  );
}

export default EnterpriseNextUp;
